import React, { useMemo, useState } from "react";
import { TextExtractor, findFirstComponentOfType } from "../../internal/TextExtractor";

interface StringLengthProps {
    string?: string,
    children?: React.ReactNode,
}

/***
 * A source component that returns the length of a string.
 * The string can be passed as a prop or as a child.
 * 
 * Params:
 *      string: The string to return the length of. If not provided, the string is expected to be in the arg-string child.
 */
export const StringLength = React.memo(function StringLength({ string, children }: StringLengthProps): React.ReactElement {

    const stringChild = useMemo(() => findFirstComponentOfType(children, "arg-string"), [children]);
    const [stringValue, setStringValue] = useState(string);

    const resultStringLength = useMemo(() => {
        return stringValue?.length || 0;
    }, [stringValue]);

    return <>
        {resultStringLength}
        {stringChild && <TextExtractor onExtractedText={setStringValue}>
            {stringChild.props.children}
        </TextExtractor>}
    </>;
});